import { render } from "./FileUploadView.vue?vue&type=template&id=72b6f5b0&scoped=true"
import script from "./FileUploadView.vue?vue&type=script&lang=js"
export * from "./FileUploadView.vue?vue&type=script&lang=js"

import "./FileUploadView.vue?vue&type=style&index=0&id=72b6f5b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b6f5b0"]])

export default __exports__